import React, { useState, useEffect } from "react";
import { TableLoader } from "../../../Common/ShimmerLoader";
import { useLocation, useNavigate } from "react-router-dom";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import ExcelJS from "exceljs";
import { Formik, Form, Field } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { DeleteGVPClearedRecord } from "../../../Apis/gvpClearanceReportApi";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { formattedDate, getCurrentDateTime1, getCurrentISTDate } from "../../../Common/helper/helpar";

const GvpInnerClearedNotInShiftReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const { data, deleteOption, isValid, formatDate, shiftName } = location.state;
  const navigate = useNavigate();
  const [gvpList, setGvpList] = useState(data);
  const [selectedBeforeImageData, setSelectedBeforeImageData] = useState(null);
  const [selectedAfterImageData, setSelectedAfterImageData] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [showImageModal1, setShowImageModal1] = useState(false);

  // Set default filter values based on formatDate
  const getDefaultFilterFields = () => {
    // Use formatDate if provided, else current date
    const baseDate = formatDate ? new Date(formatDate) : new Date();
    // Handle invalid formatDate
    if (isNaN(baseDate.getTime())) {
      baseDate = new Date();
    }
    const fromDate = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), 0, 0); // Start of day
    const now = new Date(); // Current time
    const toDate = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), now.getHours(), now.getMinutes()); // Current time on baseDate

    const formatDateTime = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    return {
      searchCircle: "",
      searchVehicleNumber: "",
      searchVehicleTypeName: "",
      searchFromDate: formatDateTime(fromDate), // e.g., "2025-05-20T00:00"
      searchToDate: formatDateTime(toDate), // e.g., "2025-05-20T23:59"
    };
  };

  const parseDeploymentDate = (dateString) => {
    if (!dateString || dateString === "N/A") return null;
    const [datePart, timePart] = dateString.split(" ");
    if (!datePart || !timePart) return null;
    const [day, month, year] = datePart.split("-").map(Number);
    const [hour, minute] = timePart.split(":").map(Number);
    const date = new Date(year, month - 1, day, hour, minute);
    return isNaN(date.getTime()) ? null : date;
  };

  const filterFields = getDefaultFilterFields();

  // Set min and max for datetime-local inputs based on formatDate
  const baseDate = formatDate ? new Date(formatDate) : new Date();
  if (isNaN(baseDate.getTime())) {
    baseDate = new Date();
  }
  const minDateTime = `${baseDate.getFullYear()}-${String(baseDate.getMonth() + 1).padStart(2, "0")}-${String(baseDate.getDate()).padStart(2, "0")}T00:00`;
  const maxDateTime = `${baseDate.getFullYear()}-${String(baseDate.getMonth() + 1).padStart(2, "0")}-${String(baseDate.getDate()).padStart(2, "0")}T23:59`;

  // Apply default filter on component mount
  useEffect(() => {
    searchReportedAtVehicleHandler(filterFields);
  }, []);

  const searchReportedAtVehicleHandler = (values) => {
    const termCircle = values.searchCircle ? values.searchCircle.toLowerCase() : "";
    const termVehicleNumber = values.searchVehicleNumber ? values.searchVehicleNumber.toLowerCase() : "";
    const termVehicleTypeName = values.searchVehicleTypeName ? values.searchVehicleTypeName.toLowerCase() : "";
    const termFromDate = values.searchFromDate ? new Date(values.searchFromDate) : null;
    const termToDate = values.searchToDate ? new Date(values.searchToDate) : null;

    // Validate that toDate is not before fromDate
    if (termFromDate && termToDate && termToDate < termFromDate) {
      toast.error("To Date must be after From Date");
      return;
    }

    const filteredData = data?.filter((item) => {
      const circleName = item?.circleName ? item.circleName.toLowerCase() : "";
      const vehicleNumber = item?.vehicleNumber ? item.vehicleNumber.toLowerCase() : "";
      const vehicleTypeName = item?.vehicleTypeName ? item.vehicleTypeName.toLowerCase() : "";
      const afterDateTime = item?.afterDateTime ? parseDeploymentDate(item.afterDateTime) : null;

      const matchesCircle = !termCircle || circleName.includes(termCircle);
      const matchesVehicleNumber = !termVehicleNumber || vehicleNumber.includes(termVehicleNumber);
      const matchesVehicleTypeName = !termVehicleTypeName || vehicleTypeName.includes(termVehicleTypeName);
      const matchesDate =
        !afterDateTime ||
        (!termFromDate && !termToDate) ||
        (termFromDate && !termToDate && afterDateTime >= termFromDate) ||
        (!termFromDate && termToDate && afterDateTime <= termToDate) ||
        (termFromDate && termToDate && afterDateTime >= termFromDate && afterDateTime <= termToDate);

      return matchesCircle && matchesVehicleNumber && matchesVehicleTypeName 
      // && matchesDate;
    });

    setGvpList(filteredData || []);
  };

  const scvReportColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "70px",
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      cell: (row) => <span>{row["zoneName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: "Circle",
      selector: (row) => row["circleName"],
      cell: (row) => <span>{row["circleName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: "Ward",
      selector: (row) => row["wardName"],
      cell: (row) => <span>{row["wardName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    ...(isValid
      ? []
      : [
        {
          name: <>Collection Point Name</>,
          selector: (row) => row?.collectionPointName || "N/A",
          cell: (row) => <span>{row?.collectionPointName || "N/A"}</span>,
          sortable: true,
          width: "120px",
        },
        {
          name: <>Collection Point Code</>,
          selector: (row) => row?.collectionPointCode || "N/A",
          cell: (row) => <span>{row?.collectionPointCode || "N/A"}</span>,
          sortable: true,
          width: "120px",
        },
      ]),
    {
      name: <>Collection Point Type</>,
      selector: (row) => row["collectionPointType"],
      cell: (row) => <span>{row["collectionPointType"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Vehicle Number</>,
      selector: (row) => row["vehicleNumber"],
      cell: (row) => <span>{row["vehicleNumber"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Vehicle Type</>,
      selector: (row) => row["vehicleTypeName"],
      cell: (row) => <span>{row["vehicleTypeName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Owner Type</>,
      selector: (row) => row["ownerTypeName"],
      cell: (row) => <span>{row["ownerTypeName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Vehicle Capacity</>,
      selector: (row) => row["vehicleCapacityName"],
      cell: (row) => <span>{row["vehicleCapacityName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Driver Name</>,
      selector: (row) => row["driverName"],
      cell: (row) => <span>{row["driverName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Driver Mobile</>,
      selector: (row) => row["mobileNumber"],
      cell: (row) => <span>{row["mobileNumber"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Cleaned Date and Time</>,
      selector: (row) => row["afterDateTime"],
      cell: (row) => <span>{row["afterDateTime"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Latitude</>,
      selector: (row) => row["collectionPointLatitude"],
      cell: (row) => <span>{row["collectionPointLatitude"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Longitude</>,
      selector: (row) => row["collectionPointLongitude"],
      cell: (row) => <span>{row["collectionPointLongitude"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Before Image</>,
      cell: (row) => {
        if (row["beforeImageUrl"]) {
          return (
            <img
              src={row["beforeImageUrl"]}
              alt="Vehicle"
              style={{
                width: "100px",
                height: "50px",
                objectFit: "cover",
                borderRadius: "10px",
                cursor: "pointer",
              }}
              onClick={() =>
                handleImageClick({
                  imageUrl: row.beforeImageUrl,
                  latitude: row.collectionPointLatitude,
                  longitude: row.collectionPointLongitude,
                  time: row.afterDateTime,
                })
              }
            />
          );
        } else {
          return <span>No image</span>;
        }
      },
      sortable: true,
      width: "120px",
    },
    {
      name: <>After Image</>,
      cell: (row) => {
        if (row["afterImageUrl"]) {
          return (
            <img
              src={row["afterImageUrl"]}
              alt="Vehicle"
              style={{
                width: "100px",
                height: "50px",
                objectFit: "cover",
                borderRadius: "10px",
                cursor: "pointer",
              }}
              onClick={() =>
                handleImageClick1({
                  imageUrl: row.afterImageUrl,
                  latitude: row.collectionPointLatitude,
                  longitude: row.collectionPointLongitude,
                  time: row.afterDateTime,
                })
              }
            />
          );
        } else {
          return <span>No image</span>;
        }
      },
      sortable: true,
      width: "120px",
    },
  ];

//   const scvReportColumnsWithDelete = [
//     ...scvReportColumns,
//     {
//       name: "Delete",
//       cell: (row) => (
//         <button
//           className="edit-swm"
//           style={{ height: 25 }}
//           onClick={() => handleDelete(row)}
//         >
//           <FontAwesomeIcon icon={faTrash} />
//         </button>
//       ),
//       sortable: true,
//       width: "120px",
//     },
//   ];

  const handleImageClick = (data) => {
    setSelectedBeforeImageData(data);
    setShowImageModal(true);
  };

  const handleImageClick1 = (data) => {
    setSelectedAfterImageData(data);
    setShowImageModal1(true);
  };

  const handleClose = () => {
    setShowImageModal(false);
    setSelectedBeforeImageData(null);
    setShowImageModal1(false);
    setSelectedAfterImageData(null);
  };

  const handleDelete = async (data) => {
    try {
      setIsLoading(true);
      const response = await DeleteGVPClearedRecord(data.secondaryCollectionId);
      if (response?.data?.statusCode === 200) {
        toast.success(response?.data?.message);
        navigate(-1);
      }
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const downloadAsExcel = async () => {
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = isValid
      ? `GVPs Cleared Report as on ${formatDate ? formattedDate(formatDate) : getCurrentISTDate()} - ${shiftName} - (at ${getCurrentDateTime1()})`
      : `No. of GVP Cleared Not In shift as on ${formatDate ? formattedDate(formatDate) : getCurrentISTDate()} - ${shiftName} - (at ${getCurrentDateTime1()})`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    const boldFont = { bold: true };

    const downloadDateTime = `Reported on: ${formattedDates} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5);
    dateTimeRow.getCell(3).font = boldFont;
    dateTimeRow.getCell(3).alignment = { horizontal: "center" };
    dateTimeRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 5) {
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
    worksheet.mergeCells(2, 3, 2, 6);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 7) {
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    worksheet.addRow([""]);

    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Circle",
      "Ward",
      ...(isValid ? [] : ["Collection Point Name"]),
      "Collection Point Type",
      ...(isValid ? [] : ["Collection Point Code"]),
      "Vehicle Number",
      "Vehicle Type",
      "Owner Type",

      "Vehicle Capacity",
      "Driver Name",
      "Driver Mobile",
      "Cleaned Date and Time",
      "Latitude", "Longitude"
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 18) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
        };
      }
    });

    gvpList.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.zoneName ?? "N/A",
        item.circleName ?? "N/A",
        item.wardName ?? "N/A",
        ...(isValid ? [] : [item.collectionPointName ?? "N/A"]),
        item.collectionPointType ?? "N/A",
        ...(isValid ? [] : [item.collectionPointCode ?? "N/A"]),
        item.vehicleNumber ?? "N/A",
        item.vehicleTypeName ?? "N/A",
        item.ownerTypeName ?? "N/A",

        item.vehicleCapacityName ?? "N/A",
        item.driverName ?? "N/A",
        item.mobileNumber ?? "N/A",
        item.afterDateTime ?? "N/A",
       item.collectionPointLatitude ?? "N/A", 
       item.collectionPointLongitude ?? "N/A",
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 18) {
          cell.alignment = { horizontal: "left" };
        } else {
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
      { width: 23 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 23 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "GVPsInnerClearanceReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="top-header page-title">
              <span>{isValid
                      ? `GVPs Cleared Report as on ${formatDate ? formattedDate(formatDate) : getCurrentISTDate()} - ${shiftName} - (at ${getCurrentDateTime1()})`
                      : `No. of GVP Cleared Not In shift as on ${formatDate ? formattedDate(formatDate) : getCurrentISTDate()} - ${shiftName} - (at ${getCurrentDateTime1()})`}</span>
            </div>
            <div className="card mt-3">
              <div className="card-body">
                <div className="page-header">
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <Formik initialValues={filterFields}>
                      {({ handleChange, values, resetForm }) => (
                        <Form id="filterForm">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group">
                                <Field
                                  name="searchCircle"
                                  placeholder="Search Circle"
                                  type="text"
                                  className="form-control bg-white"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({
                                      ...values,
                                      searchCircle: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <Field
                                  name="searchVehicleNumber"
                                  placeholder="Search Vehicle Number"
                                  type="text"
                                  className="form-control bg-white"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({
                                      ...values,
                                      searchVehicleNumber: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <Field
                                  name="searchVehicleTypeName"
                                  placeholder="Search Vehicle Type"
                                  type="text"
                                  className="form-control bg-white"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({
                                      ...values,
                                      searchVehicleTypeName: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                            {/* <div style={{ width: "20%" }}>
                              <div className="form-group">
                                <Field
                                  name="searchFromDate"
                                  placeholder="From Date and Time"
                                  type="datetime-local"
                                  className="form-control bg-white"
                                  min={minDateTime} // e.g., "2025-05-20T00:00"
                                  max={maxDateTime} // e.g., "2025-05-20T23:59"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({
                                      ...values,
                                      searchFromDate: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                            <div style={{ width: "20%" }}>
                              <div className="form-group">
                                <Field
                                  name="searchToDate"
                                  placeholder="To Date and Time"
                                  type="datetime-local"
                                  className="form-control bg-white"
                                  min={minDateTime} // e.g., "2025-05-20T00:00"
                                  max={maxDateTime} // e.g., "2025-05-20T23:59"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({
                                      ...values,
                                      searchToDate: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div> */}
                          </div>
                        </Form>
                      )}
                    </Formik>
                    <div className="d-flex" style={{marginBottom:'20px'}}>
                      <button className="btn btn-secondary me-2" onClick={() => navigate(-1)}>
                        Back
                      </button>
                      <button className="btn btn-excel" onClick={downloadAsExcel}>
                        <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                      </button>
                    </div>
                  </div>
                </div>

                <CustomDataTable
                  data={gvpList}
                  columns={scvReportColumns}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showImageModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Before Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedBeforeImageData && (
            <div style={{ position: "relative" }}>
              <img
                src={selectedBeforeImageData.imageUrl}
                alt="Before Image"
                style={{
                  width: "100%",
                  height: "400px",
                }}
              />
              {/* <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: "rgba(0, 0, 0, 0.6)",
                  color: "white",
                  padding: "10px",
                  fontSize: "14px",
                  borderBottomLeftRadius: "5px",
                  borderBottomRightRadius: "5px",
                }}
              >
                <p style={{ margin: 0 }}>
                  <strong>Latitude:</strong> {selectedBeforeImageData.latitude ?? "N/A"}
                </p>
                <p style={{ margin: 0 }}>
                  <strong>Longitude:</strong> {selectedBeforeImageData.longitude ?? "N/A"}
                </p>
                <p style={{ margin: 0 }}>
                  <strong>Date:</strong> {selectedBeforeImageData.time ?? "N/A"}
                </p>
              </div> */}
            </div>
          )}
        </Modal.Body>
      </Modal>
      <Modal show={showImageModal1} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>After Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedAfterImageData && (
            <div style={{ position: "relative" }}>
              <img
                src={selectedAfterImageData.imageUrl}
                alt="After Image"
                style={{
                  width: "100%",
                  height: "400px",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: "rgba(0, 0, 0, 0.6)",
                  color: "white",
                  padding: "10px",
                  fontSize: "14px",
                  borderBottomLeftRadius: "5px",
                  borderBottomRightRadius: "5px",
                }}
              >
               
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GvpInnerClearedNotInShiftReport;